export default __webpack_public_path__ + "static/media/follow_up.cced5c32.svg";